// extracted by mini-css-extract-plugin
module.exports = {"cell":"Item_cell__-xXFa","checkboxCell":"Item_checkboxCell__NwrBJ","checkbox":"Item_checkbox__z-v_F","simIcon":"Item_simIcon__2NjcN"};